import request from "@/utils/request";
// 统计分析
export function countAnalysis(data) {
  return request({
    method: "post",
    url: "/statistics/countAnalysis",
    data: data,
  }).then((res) => res.data);
}
// 统计分析详情
export function countAnalysisDetail(data) {
  return request({
    method: "post",
    url: "/statistics/countAnalysisDetail",
    data: data,
  }).then((res) => res.data);
}
//   统计分析导出1
export function exportCountAnalysis(data) {
  return request({
    method: "post",
    url: "/statistics/exportCountAnalysis",
    data: data,
  }).then((res) => res.data);
}
// 所有的导出
export function download(params) {
  return request({
    url: "/common/download",
    method: "get",
    params: params,
    responseType: "blob",
  }).then((res) => res.data);
}
//   统计分析详情导出
export function exportCountAnalysisDetail(data) {
  return request({
    method: "post",
    url: "/statistics/exportCountAnalysisDetail",
    data: data,
  }).then((res) => res.data);
}
// 卡券发放清单
export function selectGrantCountByDept(params) {
  return request({
    url: "/statistics/selectGrantCountByDept",
    method: "get",
    params: params,
  }).then((res) => res.data);
}
// 卡券发放导出
export function exportGrantCountByDept(params) {
  return request({
    url: "/statistics/exportGrantCountByDept",
    method: "get",
    params: params,
  }).then((res) => res.data);
}
